import { cn } from '@/lib/utils';
import NoItems from '@/components/ui/NoItems.tsx';
import { columnLabelClass } from '@/components/ui/typography.ts';
import { AcceptanceDocumentVm } from '@/features/dashboard/bookingChanges/types/ChangePackageFlowViewModel.ts';
import ClientAcceptanceDocumentRow from './ClientAcceptanceDocumentRow.tsx';

interface ClientAcceptanceDocumentListProps
  extends React.HTMLAttributes<HTMLDivElement> {
  documents: AcceptanceDocumentVm[];
}

/**
 * Dokumenty, które zapisujący podpisze razem z akceptacją zmian — gotowy wybór
 * operatora z kroku W2, tutaj już bez zaznaczania.
 */
const ClientAcceptanceDocumentList = ({
  documents,
  className,
  ...props
}: ClientAcceptanceDocumentListProps) => (
  <div
    className={cn(
      'rounded-[11px] border border-neutral-200 px-[18px] py-4',
      className,
    )}
    {...props}
  >
    <div className={columnLabelClass}>Dokumenty do akceptacji</div>

    {documents.length === 0 ? (
      <NoItems
        className="mt-2.5"
        title="Brak dokumentów do podpisu"
        description="Te zmiany nie wymagają ponownej akceptacji żadnego dokumentu."
      />
    ) : (
      <div className="mt-2.5 flex flex-col">
        {documents.map((document, index) => (
          <ClientAcceptanceDocumentRow
            key={document.id}
            className={cn(index > 0 && 'border-t border-neutral-100')}
            document={document}
          />
        ))}
      </div>
    )}
  </div>
);

export default ClientAcceptanceDocumentList;
